<script>
const serviceCostListReport = importVueComp('components/reports', 'ServiceCostListReport', 'custom');
export default {
    name: "custom-service-costlist-report",
    mixins: [serviceCostListReport],
    methods: {
        async beforeRender(report) {
            const beforeRender = await serviceCostListReport.methods.beforeRender.call(this, report);
            const res = await api.get('/api/faresreportheadermessage/', {filters: '{"View": true}'});
            const activeMessage = Array.isArray(res) ? res[0] : null;

            if (activeMessage) {
                this.headerMesssage = {
                    colspan: report.serverColumnsHeader ? report.serverColumnsHeader.length : this.headerMesssage.colspan,
                    html: activeMessage.Text,
                };
            } else {
                this.headerMesssage = {
                    colspan: report.serverColumnsHeader ? report.serverColumnsHeader.length : 16,
                    html: false,
                    rows: [
                        { text: "Rates per passenger per service unless indicated, in dollars, subject to change.", class: "white-space-nowrap" },
                        { text: "Excursion's rates don't include entrance fees.", class: "white-space-nowrap" },
                        { text: "Navigation's rates don't include transfers or Port fees.", class: "white-space-nowrap" },
                        { text: "Kindly notice that these rates are not valid for 24th, 25th, 31st December & 01st January, for this special dates the extra charge will be 100%.", class: 'text-danger white-space-nowrap' },
                    ]
                };
            }

            this.headerMesssage = Object.assign({}, this.headerMesssage);
            return beforeRender;

        }
    }
}
</script>
